import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Loading from '../../common/Loading/Loading';
import { analyticsTrack } from '../../../analyticsUtils';
import { getRequest } from '../../../requestUtils';
import './ConsultantComparison.scss';
function ConsultantComparison(_ref) {
  var consultants = _ref.consultants,
    projectResourceId = _ref.projectResourceId;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedButtons = _useState2[0],
    setSelectedButtons = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comparisonResult = _useState4[0],
    setComparisonResults = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var hasLoaded = useRef(false);
  useEffect(function () {
    analyticsTrack('Viewed consultant comparison tab', {
      location: 'Projects view'
    });
  }, []);
  var getConsultantComparison = function getConsultantComparison() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedButtons;
    setIsLoading(true);
    getRequest("/projects/".concat(projectResourceId, "/compare-consultants"), {
      proposal_ids: ids
    }).then(function (_ref2) {
      var data = _ref2.data;
      setComparisonResults(data);
      setIsLoading(false);
    })["catch"](function (error) {
      console.error('Error fetching comparison results:', error);
      setIsLoading(false);
    });
  };
  useEffect(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var idsParam = urlParams.get('consultants_Ids');
    if (idsParam) {
      var ids = idsParam.split(',');
      setSelectedButtons(ids);
      if (!hasLoaded.current) {
        getConsultantComparison(ids);
      }
    }
    hasLoaded.current = true; // Mark as loaded after initial read
    // eslint-disable-next-line
  }, []);
  useEffect(function () {
    if (!hasLoaded.current) return; // Skip first render
    var url = new URL(window.location);
    if (selectedButtons.length > 0) {
      url.searchParams.set('consultants_Ids', selectedButtons.join(','));
    } else {
      url.searchParams["delete"]('consultants_Ids');
    }
    if (selectedButtons.length < 2) {
      setComparisonResults([]);
    }
    window.history.replaceState({}, '', url);
  }, [selectedButtons]);
  var renderConsultantName = function renderConsultantName() {
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2"
    }, /*#__PURE__*/React.createElement("strong", null, "Consultant Name")), /*#__PURE__*/React.createElement("div", {
      className: "col-4"
    }, comparisonResult.consultant_name[0]), /*#__PURE__*/React.createElement("div", {
      className: "col-4"
    }, comparisonResult.consultant_name[1]));
  };
  var renderHourlyRate = function renderHourlyRate() {
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2"
    }, /*#__PURE__*/React.createElement("strong", null, "Hourly Rate")), /*#__PURE__*/React.createElement("div", {
      className: "col-4 fw-semibold"
    }, comparisonResult.hourly_rate[0]), /*#__PURE__*/React.createElement("div", {
      className: "col-4 fw-semibold"
    }, comparisonResult.hourly_rate[1]));
  };
  var renderUsSponsorshipNeeded = function renderUsSponsorshipNeeded() {
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2"
    }, /*#__PURE__*/React.createElement("strong", null, "US Sponsorship")), /*#__PURE__*/React.createElement("div", {
      className: "col-4 fw-semibold"
    }, comparisonResult.us_sponsorship_needed[0]), /*#__PURE__*/React.createElement("div", {
      className: "col-4 fw-semibold"
    }, comparisonResult.us_sponsorship_needed[1]));
  };
  var renderProjectFitSummaryPros = function renderProjectFitSummaryPros() {
    var summaries = comparisonResult.project_fit_summary || [];
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2"
    }, /*#__PURE__*/React.createElement("strong", null, "Strengths")), summaries.map(function (summary, index) {
      var _summary$strong_fit;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-4",
        key: "strong-".concat(index)
      }, (_summary$strong_fit = summary.strong_fit) === null || _summary$strong_fit === void 0 ? void 0 : _summary$strong_fit.map(function (item, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "mb-3 body-text-3 align-self-center"
        }, item);
      }));
    }));
  };
  var renderExpertiseResponses = function renderExpertiseResponses() {
    if (!comparisonResult.expertise_responses) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2 fw-bold p-3"
    }, /*#__PURE__*/React.createElement("strong", null, "Expertise Responses")), comparisonResult.expertise_responses.map(function (response, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-4 p-3",
        key: "expertise-".concat(index)
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Must Have:"), Object.entries(response.priority).map(function (_ref3) {
        var _value$response, _value$response2;
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return /*#__PURE__*/React.createElement("div", {
          className: "mb-2",
          key: key
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, key.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        }), ":"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, value.values.join(', '))), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Has Experience:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, (_value$response = value.response) === null || _value$response === void 0 ? void 0 : _value$response[0])), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Comment:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, (_value$response2 = value.response) === null || _value$response2 === void 0 ? void 0 : _value$response2[1])));
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Others:"), Object.entries(response.non_priority).map(function (_ref5) {
        var _value$response3, _value$response4;
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return /*#__PURE__*/React.createElement("div", {
          className: "mb-2",
          key: key
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, key.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        }), ":"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, value.values.join(', '))), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Has Experience:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, (_value$response3 = value.response) === null || _value$response3 === void 0 ? void 0 : _value$response3[0])), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Comment:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, (_value$response4 = value.response) === null || _value$response4 === void 0 ? void 0 : _value$response4[1])));
      })));
    }));
  };
  var renderScreeningQuestions = function renderScreeningQuestions() {
    var responses = comparisonResult.screening_questions_responses;
    if (!responses || !Array.isArray(responses)) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "row  gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2 fw-bold p-3"
    }, /*#__PURE__*/React.createElement("strong", null, "Screening Questions")), responses.map(function (questionObj, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-4 p-3",
        key: "screeing-".concat(index)
      }, questionObj.map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mb-2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Question:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, item.question)), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Answer:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, item.answer)), /*#__PURE__*/React.createElement("div", {
          className: "d-flex gap-2"
        }, /*#__PURE__*/React.createElement("strong", null, "Selection:"), /*#__PURE__*/React.createElement("span", {
          className: "fst-italic word-wrap body-text-3 align-self-center",
          style: {
            wordBreak: 'break-word'
          }
        }, String(item.answer_selection))));
      }));
    }));
  };
  var renderProjectFitSummaryCons = function renderProjectFitSummaryCons() {
    var summaries = comparisonResult.project_fit_summary || [];
    return /*#__PURE__*/React.createElement("div", {
      className: "row gap-3 fs-6 border-top p-3 justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-2"
    }, /*#__PURE__*/React.createElement("strong", null, "Potential Gaps")), summaries.map(function (summary, index) {
      var _summary$potential_mi;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-4",
        key: "misfit-".concat(index)
      }, (_summary$potential_mi = summary.potential_misfit) === null || _summary$potential_mi === void 0 ? void 0 : _summary$potential_mi.map(function (item, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "mb-3 body-text-3 align-self-center"
        }, item);
      }));
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "consultant-comparison w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "consultant-container__list d-flex flex-wrap flex-column gap-3 my-2 box-shadow-1 p-4 justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-card-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "project-section-title"
  }, "Consultant Comparison")), /*#__PURE__*/React.createElement("div", {
    className: "consultant-container__button-list d-flex flex-wrap gap-3 justify-content-center p-3 bg-body-tertiary"
  }, /*#__PURE__*/React.createElement(Select, {
    menuIsOpen: selectedButtons.length < 2,
    isMulti: true,
    options: consultants.map(function (consultant) {
      return {
        value: consultant.proposalResourceId,
        label: consultant.consultantName
      };
    }),
    value: selectedButtons.map(function (id) {
      var found = consultants.find(function (c) {
        return String(c.proposalResourceId) === String(id);
      });
      return found ? {
        value: found.proposalResourceId,
        label: found.consultantName
      } : {
        value: id,
        label: id
      };
    }),
    onChange: function onChange(selected) {
      setSelectedButtons(selected.map(function (opt) {
        return opt.value;
      }));
    },
    isOptionDisabled: function isOptionDisabled(option) {
      return selectedButtons.length >= 2 && !selectedButtons.includes(option.value);
    },
    classNamePrefix: "clora-multiselect"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-sm p-2",
    onClick: function onClick() {
      return getConsultantComparison();
    },
    disabled: selectedButtons.length < 2
  }, "Compare Consultants"))), isLoading && /*#__PURE__*/React.createElement(Loading, null), !isLoading && selectedButtons.length >= 2 && Object.keys(comparisonResult).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "w-100 compare-container__results my-2 box-shadow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-summary-card-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "project-section-title"
  }, "Comparison Results"))), /*#__PURE__*/React.createElement("div", {
    className: "compare-container__results-display container d-flex flex-column gap-3 p-3 justify-content-center"
  }, renderConsultantName(), renderHourlyRate(), renderUsSponsorshipNeeded(), renderProjectFitSummaryPros(), renderProjectFitSummaryCons(), renderExpertiseResponses(), renderScreeningQuestions())));
}
ConsultantComparison.propTypes = {
  consultants: PropTypes.arrayOf(PropTypes.shape({
    proposalResourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    consultantName: PropTypes.string.isRequired
  }))
};
ConsultantComparison.defaultProps = {
  consultants: []
};
export default ConsultantComparison;